export default __webpack_public_path__ + "static/media/banner.f11201c5.png";